import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { createUsageTracker } from '../utils/usageTracker';
import { compartmentForPath } from '../utils/compartments';

// enabled: only track authenticated sessions.
export function useUsageTracker(enabled) {
  const location = useLocation();
  const trackerRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    const tracker = createUsageTracker();
    trackerRef.current = tracker;
    tracker.start();
    return () => { tracker.stop(); trackerRef.current = null; };
  }, [enabled]);

  useEffect(() => {
    if (!enabled || !trackerRef.current) return;
    const key = compartmentForPath(location.pathname);
    if (key) trackerRef.current.enter(key);
  }, [enabled, location.pathname]);
}
